import StoryblokService from "@lib/storyblok/templates/storyblok-service.class";
class EntityBrandingStoryblokService extends StoryblokService {
  constructor() {
    super();
    this.draft = process.env.NEXT_PUBLIC_STORYBLOK_ON_DRAFT === "true";
    this.baseURL += "/financial_entity/branding";
  }
  async getPlatformLogo() {
    const image = await this.getSingleImage("".concat(this.baseURL, "/platform_logo").concat(this.draft ? "_test" : ""));
    return image;
  }
  async getPlatformContrastLogo() {
    const image = await this.getSingleImage("".concat(this.baseURL, "/platform_logo_contrast").concat(this.draft ? "_test" : ""));
    return image;
  }
  async getPlatformIcon() {
    return this.getSingleImage("".concat(this.baseURL, "/platform_icon").concat(this.draft ? "_test" : ""));
  }
  async getEntityLogo() {
    return this.getSingleImage("".concat(this.baseURL, "/entity_logo").concat(this.draft ? "_test" : ""));
  }
  async getEntityIcon() {
    return this.getSingleImage("".concat(this.baseURL, "/entity_icon"));
  }
  async getEntityIconSpecialColor() {
    return this.getSingleImage("".concat(this.baseURL, "/entity_icon_special_color"));
  }
  async getEntityPointsLogo() {
    const image = await this.getSingleImage("".concat(this.baseURL, "/entity_points_logo"));
    return image;
  }
  async getEntityPointsIcon() {
    return this.getSingleImage("".concat(this.baseURL, "/entity_points_icon"));
  }
  async getFooterLogo() {
    return this.getSingleImage("".concat(this.baseURL, "/footer/footer_logo"));
  }
  async getFooterContrastLogo() {
    return this.getSingleImage("".concat(this.baseURL, "/footer/footer_contrast"));
  }
  async getAssociationLogo() {
    return this.getSingleImage("".concat(this.baseURL, "/footer/association_logo"));
  }
  async getTermsAndConditions() {
    return this.getSinglePdf("".concat(this.baseURL, "/terms_and_conditions"));
  }
  async getPrivacyPolicy() {
    return this.getSinglePdf("".concat(this.baseURL, "/privacy_policies"));
  }
  async getTermsAndConditionsServer(language) {
    const url = language === "en" ? "terms_and_conditions_en" : "terms_and_conditions_es";
    console.log("url", url);
    return this.getSinglePdfServer("".concat(this.baseURL, "/").concat(url));
  }
  async getPrivacyPolicyServer(language) {
    const url = language === "en" ? "privacy_policies_en" : "privacy_policies_es";
    return this.getSinglePdfServer("".concat(this.baseURL, "/").concat(url));
  }
  async getCommunicationMessage() {
    try {
      const data = await this.getStoryblokData("".concat(this.baseURL, "/communication_message").concat(this.draft ? '_test' : ''));
      if (data && data.length > 0) {
        return data[0];
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching communication message:", error);
      return [];
    }
  }
}
const entityBrandingStoryblokService = new EntityBrandingStoryblokService();
export default entityBrandingStoryblokService;